import Component from '../FormConfig/src/FormConfigModal'

Component.install = Vue => {
  Vue.component(Component.name, Component)
}
export default Component
